import React, { useState, useEffect } from 'react';
import { Card, Typography, Tag, Space, Button, Empty, message } from 'antd';
import { EditOutlined, PlusCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import axios from 'axios';
import AirwayBillHistory from '../orders/AirwayBillHistory';

const { Text } = Typography;

const StaffManagement = () => {
  const [history, setHistory] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/orders/airway-bill-history/');
      const { data } = response;
      console.log('History response:', data);
      
      if (data.results && Array.isArray(data.results)) {
        setHistory(data.results);
      } else if (Array.isArray(data)) {
        setHistory(data);
      } else {
        setHistory([]);
        console.error('Invalid history data format:', data);
        message.error('获取历史记录失败');
      }
    } catch (error) {
      console.error('Error fetching history:', error);
      setHistory([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  // Get unique operators from history
  const operators = [...new Set(history.map(record => record.username))];

  // Filter history by selected operator
  const filteredHistory = selectedOperator
    ? history.filter(record => record.username === selectedOperator)
    : history;

  const handleOperatorClick = (operator) => {
    setSelectedOperator(operator === selectedOperator ? null : operator);
  };

  return (
    <Card 
      title={
        <Space direction="vertical" style={{ width: '100%' }}>
          <div>员工操作记录</div>
          <div style={{ marginTop: 16 }}>
            <Text type="secondary" style={{ marginRight: 8 }}>按员工筛选:</Text>
            {operators.map(operator => (
              <Tag
                key={operator}
                color={operator === selectedOperator ? '#1890ff' : 'default'}
                style={{ cursor: 'pointer', marginBottom: 8 }}
                onClick={() => handleOperatorClick(operator)}
              >
                {operator}
              </Tag>
            ))}
            {selectedOperator && (
              <Button 
                type="link" 
                onClick={() => setSelectedOperator(null)}
                style={{ marginLeft: 8 }}
              >
                清除筛选
              </Button>
            )}
          </div>
        </Space>
      }
      loading={loading}
    >
      {filteredHistory.length > 0 ? (
        <AirwayBillHistory history={filteredHistory} />
      ) : (
        <Empty description="暂无操作记录" />
      )}
    </Card>
  );
};

export default StaffManagement;
